module.exports = "/v2/pages/dashboard/dist/4b066a5d603ef3469e7d41c78a7a64ec.svg";